import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import { FolderOpenOutlined, FolderOutlined, HomeOutlined } from '@ant-design/icons';
import { Bread, Folder } from './styles';
export default function Breadcrumbs({
  isLoading,
  path,
  setPath
}) {
  const dirs = path.split('/').filter(p => p !== '');
  const crumbs = dirs.map((p, i) => {
    return {
      path: dirs.slice(0, i + 1).join('/') + '/',
      folderName: p
    };
  });
  return <Bread data-testid="breadcrumbs-doc">
      <Folder data-testid="breadcrumbs-doc-home" onClick={() => setPath('/')}>
        <HomeOutlined /> Home
      </Folder>{' '}
      {crumbs.length > 0 && <>→ </>}
      {isLoading ? <ClipLoader size={14} color="#FFFFFF" /> : crumbs.map((bread, i, row) => {
      return i + 1 === row.length ? <span key={i}>
              <FolderOutlined /> {bread.folderName}
            </span> : <Folder key={i} onClick={() => setPath(bread.path)}>
              <FolderOpenOutlined /> {bread.folderName} →{' '}
            </Folder>;
    })}
    </Bread>;
}